import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  DatePicker,
  Select,
  Row,
  Col,
  message,
  Typography,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";

const { Option } = Select;
const { Title } = Typography;

const AgreementForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [file, setFile] = useState(null);
  const [owners, setOwners] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [inspections, setInspections] = useState([]);

  useEffect(() => {
    fetchDropdownData();
    if (formData) {
      form.setFieldsValue({
        ...formData,
        startDate: formData.startDate ? moment(formData.startDate) : null,
        endDate: formData.endDate ? moment(formData.endDate) : null,
      });
    }
  }, [formData]);

  const fetchDropdownData = async () => {
    try {
      const [ownersResponse, vehiclesResponse, inspectionsResponse] = await Promise.all([
        axios.get("http://93.127.203.113:5005/owners"),
        axios.get("http://93.127.203.113:5005/vehicles"),
        axios.get("http://93.127.203.113:5005/inspections"),
      ]);

      setOwners(ownersResponse.data);
      setVehicles(vehiclesResponse.data);
      setInspections(inspectionsResponse.data);
    } catch (error) {
      message.error("Failed to fetch dropdown data.");
    }
  };

  const handleFileChange = (info) => {
    if (info.file.status === "removed") {
      setFile(null);
    } else {
      setFile(info.file.originFileObj);
    }
  };

  const onFinish = async (values) => {
    if (!file) {
      message.error("Please upload an agreement document");
      return;
    }

    const formPayload = new FormData();
    Object.keys(values).forEach((key) => {
      formPayload.append(key, values[key]);
    });

    formPayload.set("startDate", values.startDate.format("YYYY-MM-DD"));
    if (values.endDate) {
      formPayload.set("endDate", values.endDate.format("YYYY-MM-DD"));
    }

    formPayload.append("agreementDocument", file);

    try {
      await axios.post("http://93.127.203.113:5005/agreements", formPayload, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      message.success("Agreement saved successfully");
      form.resetFields();
      setFile(null);
      closeModal();
      refetchData();
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to save agreement");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
        {formData.agreementId ? "Edit Agreement" : "Add Agreement"}
      </Title>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          padding: "20px",
        }}
      >
        {/* Form Fields */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Owner"
              name="ownerId"
              rules={[{ required: true, message: "Please select an owner" }]}
            >
              <Select placeholder="Select an owner">
                {owners.map((owner) => (
                  <Option key={owner.id} value={owner.id}>
                    {owner.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Vehicle"
              name="vehicleId"
              rules={[{ required: true, message: "Please select a vehicle" }]}
            >
              <Select placeholder="Select a vehicle">
                {vehicles.map((vehicle) => (
                  <Option key={vehicle.id} value={vehicle.id}>
                    {vehicle.plateNumber}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Vehicle Inspection"
              name="vehicleInspectionId"
              rules={[{ required: true, message: "Please select an inspection" }]}
            >
              <Select placeholder="Select an inspection">
                {inspections.map((inspection) => (
                  <Option key={inspection.id} value={inspection.id}>
                    {`Inspection #${inspection.id} (${inspection.inspectionDate})`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Price Per Day"
              name="pricePerDay"
              rules={[{ required: true, message: "Please enter price per day" }]}
            >
              <Input type="number" placeholder="Enter price per day" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Agreement Document">
              <Upload
                listType="text"
                beforeUpload={(file) => {
                  setFile(file);
                  return false;
                }}
                onRemove={() => setFile(null)}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Upload Agreement</Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Start Date"
              name="startDate"
              rules={[{ required: true, message: "Please select start date" }]}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="End Date" name="endDate">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            style={{ backgroundColor: "#0c8c49", borderColor: "#0c8c49" }}
          >
            Save
          </Button>
          <Button
            htmlType="button"
            onClick={() => {
              form.resetFields();
              setFile(null);
            }}
            style={{ marginLeft: "10px", borderColor: "#0c8c49", color: "#0c8c49" }}
          >
            Reset
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AgreementForm;
